import React from 'react'
import { Box, Grid, Stack, Typography, Button, IconButton } from "@mui/material"
import HostelCaurosel from "../HostelCaurosel"
import { ReactComponent as RightUpArrowIcon } from "../../Icons/rightUpArrowWhite.svg"
import parse from "html-react-parser";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

export default function Hostels({ hostelData }) {

    const navigate = useNavigate()
    const language = useSelector((state) => state.language.language)
    const styles = useSelector((state) => state.styles)
    const {t} = useTranslation()
    console.log(styles, 'hostelData')

    return (
        <>
            <Box px={{xs : 2, lg :5}} width="100%" sx={{mt : '60px'}}>
                <Stack alignItems="center">
                    <Typography p={2} width="fit-content" variant="h6_1" color="primary" border="1px solid #27BAC4" padding="10px 50px" borderRadius="50px" letterSpacing="1.1px" sx={{...styles.h2}}>{t("HOSTELS")}</Typography>
                </Stack>
                <Box sx={{mt : '40px', mx : {xs : '10px', lg : '20px'}}}>
                {hostelData?.map((item, index) => (
                    <Grid key={index} container mt={5} p={3}  rowGap={'40px'} columnGap={'40px'} sx={{ background: "#EFF4FC", borderRadius: "20px" }}>
                        <Grid xs={12} md={4} lg={4.5}>
                            <Stack margin="0 auto" sx={{ maxWidth: {xs : '100%', sm : '100%', lg : '100%'}, height: "100%", borderRadius: "24px" }}>
                                <HostelCaurosel images={item?.images} />
                            </Stack>
                        </Grid>
                        <Grid xs={12} md={7.2} lg={7.1} sx={{ position : 'relative'}}>
                            <Stack textAlign="left" height="100%" sx={{mt : {xs : 0, sm :0, lg : 0}, px : {xs : 0, sm : 3, lg : 0}}}>
                                <Typography mt={2} sx={{...styles.h2}}>{item?.title?.[language]}</Typography>
                                <Typography mt={0} style={{color : '#4d4d4d', ...styles.subTimeDate}}>{item?.location?.[language]}</Typography>
                                <Typography mt={3} sx={{...styles.subheading}}>{t("About the Hostel")}</Typography>
                                <Typography mt={1} sx={{...styles.subheadingDescription, color : '#434343', mb : '70px'}}>{Boolean(item?.description) ? parse(item?.description?.[language]) : ""}</Typography>
                                
                                    <Button onClick={() => navigate(`/hostelreview/${item?.id}`)} variant="contained" endIcon={<RightUpArrowIcon />} sx={{position : 'absolute', bottom : 0, right : 0, width: "auto", height: "auto", padding: "10px 24px", backgroundColor: "#007eca", borderRadius: "80px", color: "white", textTransform: "none", letterSpacing: "1px", fontWeight: 700, fontSize: "16" }}>{t("View")}</Button>
                               
                            </Stack>
                        </Grid>
                    </Grid>
                ))}
                </Box>
                {/* <Grid container mt={5} p={3} rowGap={2} columnGap={3} sx={{ background: "#EFF4FC", borderRadius: "20px" }}>
                    <Grid xs={12} md={4.5}>
                        <Stack margin="0 auto" sx={{ maxWidth: "440px", maxHeight: "300px", borderRadius: "24px" }}>
                            <Carousel />
                        </Stack>
                    </Grid>
                    <Grid xs={12} md={7}>
                        <Stack textAlign="left" height="100%">
                            <Typography mt={2} variant='h4_1'>Vinga Hall @ RG</Typography>
                            <Typography mt={3} variant='h9_1'>About the Hostel</Typography>
                            <Typography mt={1} variant='h9_4'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla.</Typography>
                            <Stack direction="row" justifyContent="end" alignItems='end' height="100%">
                                <Button variant="contained" endIcon={<RightUpArrowIcon />} sx={{ width: "100px", height: "40px", padding: "10px 30px", backgroundColor: "#007eca", borderRadius: "80px", color: "white", textTransform: "none", letterSpacing: "1px", fontWeight: 700, fontSize: "16" }}>View</Button>
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid> */}
            </Box>
        </>
    )
}
